let globalWatcherCreated = false;
let initialSyncDone = false;
let debug = null;

const HOME_MODE_ROUTES = [
  'terminos-y-condiciones',
  'medios-de-pago',
  'seguridad-y-privacidad',
  'politica-datos-personales',
  'beneficios',
  'retiro-y-entrega',
  'nuestros-locales',
  'postulaciones',
  'concursos-promociones',
  'blog',
  'bases-concurso',
  'ganadores-concurso',
  'asociados',
  'quienes-somos',
];

export function calcularModalidad(path) {
  const pathSegments = path.split('/').filter(segment => segment !== '');
  const currentMode = pathSegments.length > 0 ? pathSegments[0] : 'home';
  
  // Si es un local específico, usar el segundo segmento
  if (currentMode === 'nuestros-locales' && pathSegments[1]) {
    return pathSegments[1]; // 'local-vitacura'
  }
  
  const isHomeMode = currentMode === 'home' || HOME_MODE_ROUTES.includes(currentMode);
  return isHomeMode ? 'home' : currentMode;
}

export function verificarSincronizacion(path, modo) {
  const modoEsperado = calcularModalidad(path);
  const sincronizado = modo === modoEsperado;

  if (debug) {
    debug.log('debug -> [COMPOSABLE MODOSISTEMA], verificacion: ', {
      path,
      modo,
      modoEsperado,
      sincronizado
    });
  }

  return sincronizado;
}

function actualizarModoSistema(modo_sistema, nuevaModalidad, origen) {
  if (modo_sistema.value !== nuevaModalidad) {
    if (debug) {
      debug.log(`debug -> [COMPOSABLE MODOSISTEMA], [${origen}] ${modo_sistema.value} → ${nuevaModalidad}`);
    }
    modo_sistema.value = nuevaModalidad;
  }
}

function getCallerInfo() {
  const stack = new Error().stack;
  const lines = stack.split('\n');

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (line.includes('.vue') || line.includes('layouts/') || line.includes('pages/')) {
      const match = line.match(/([^\/\\]+\.vue)/);
      if (match) {
        return match[1];
      }
    }
  }

  return 'Unknown';
}

export function useModoSistema() {
  const route = useRoute();
  const instanceId = Math.random().toString(36).substring(7);

  if (!debug) {
    const config = useRuntimeConfig();
    debug = {
      enabled: config.public.modo === 'DEV',
      log(...args) {
        if (this.enabled) console.log(...args);
      },
      error(...args) {
        if (this.enabled) console.error(...args);
      },
    };
  }

  const caller = getCallerInfo();
  debug.log(`debug -> [COMPOSABLE MODOSISTEMA], [INSTANCIA-${instanceId}] Llamado desde: ${caller} | route.path: ${route.path}`);

  const modalidad = calcularModalidad(route.path);
  const modo_sistema = useState('modo_sistema', () => modalidad);

  if (!initialSyncDone) {
    initialSyncDone = true;
    actualizarModoSistema(modo_sistema, modalidad, 'SYNC-INICIAL');
  }

  if (!globalWatcherCreated) {
    globalWatcherCreated = true;
    debug.log('debug -> [COMPOSABLE MODOSISTEMA], [WATCHER] Creado');

    watch(() => route.path, (newPath, oldPath) => {
      if (newPath === oldPath) return;

      debug.log(`debug -> [COMPOSABLE MODOSISTEMA], [WATCHER] "${oldPath}" → "${newPath}"`);

      const newModalidad = calcularModalidad(newPath);
      actualizarModoSistema(modo_sistema, newModalidad, 'WATCHER');
    }, { immediate: false });
  }

  return {
    modo_sistema,
  };
}
